import { TileProps } from '..';
import { useObjectMarkerLocalizer } from '../../ObjectMarker';
import { getIconAndLabelTextFromType } from '../../ObjectMarker/__internal__/getIconAndLabelTextFromType';
import { useKeyboardTooltip } from '../../Settings';
import bundle from '../NovaComponents-Tile-gui-icu.properties';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const useTileKeyboardTooltip = (props: TileProps) => {
  const localize = useTextLocalizer();
  const objectMarkerLocalize = useObjectMarkerLocalizer();
  const objectMarkers = props.objectMarkers ? [...props.objectMarkers] : [];
  if (props.favorited) {
    objectMarkers.unshift({ type: 'Favorite' });
  }

  const keyboardTooltips: string[] = [];
  if (props.disableInteractiveMode) {
    // Only show the keyboard tooltip of its content when interactive mode is disabled
    if (props.title) {
      keyboardTooltips.push(props.title);
    }

    for (const { type } of objectMarkers) {
      const { labelText } = getIconAndLabelTextFromType(type, objectMarkerLocalize);
      keyboardTooltips.push(labelText);
    }

    if (props.selected) {
      keyboardTooltips.push(localize('selected.keyboard.tooltip.label'));
    }
  } else {
    // Show the keyboard tooltip of how to enter interactive mode if enabled
    keyboardTooltips.push(localize('interactiveMode.hint.keyboardTooltip.label'));
  }

  const setKeyboardTooltipRef = useKeyboardTooltip({ tooltip: keyboardTooltips.join(', ') });

  return setKeyboardTooltipRef;
};
